import {FormModel} from "./form.model.abstract";
import {ValidatorFn} from "@angular/forms";

/**
 * Input to select the roof pitch
 * @inheritDoc
 */
export class FormModelRoofpitch extends FormModel {

  /**
   * The two different roof types to show in the output.
   */
  public static readonly TYPE_PITCH = 'pitch';
  public static readonly TYPE_PENT = 'pent';

  /**
   * @inheritDoc
   */
  public type = 'roofpitch';

  /**
   * @inheritDoc
   * @param id
   * @param validators
   * @param unit
   * @param value
   * @param info
   * @param fieldType
   */
  constructor(id: string, validators: ValidatorFn[] = [], unit: string = null, value: any = null, info: boolean = true,
              fieldType: string = FormModelRoofpitch.TYPE_PITCH) {
    super(id, validators, unit, value, info);

    this.fieldData.fieldType = fieldType;
  }

  /**
   * get a clone of the current object
   */
  public clone(): FormModelRoofpitch {
    // @ts-ignore
    return new this.constructor(this.id, this.validators, this.unit, this.value, this.info);
  }
}
